module.exports = {
  title: "LesPark- 全球拉拉直播交友官網",
  description: "LesPark為全球les提供交友渠道，集pc直播和移動社交軟體，是拉拉專屬交友泛娛樂平臺。在這裏，妳可以通過網頁開啟直播，與粉絲好友零距離實時互動；能夠依據定位尋找附近她或參加各種活動，與附近人群建立良好、健康的社交關系。",
  header: {
    nav1: "熱門直播",
    nav2: "在線充值",
    nav3: "主播中心",
    nav3_1: "主播管理後台",
    nav3_2: "開始PC直播",
    nav3_3: "成為簽約主播",
    nav3_4: "PC直播指南",
    nav3_5: "PC开播",
    nav3_6: "愛豆提現",
    nav4: "聯繫我們",
    nav5: "關於我們",
    nav6: "登錄/註冊",
    nav7: "公司簡介",
    me1: "在線充值",
    me2: "退出",
    live: "直播",
    topic: "話題",
    baihuaTitle: "百花計劃",
    baihuaAward: "千萬補貼",
    ContactUs: "聯系客服",
    myHome: "我的首頁",
    jihua:"悸花樂讀",
  },
  login: {
    nav1: "登錄",
    nav2: "註冊",
    nav3_1: "快速登錄",
    nav3_2: "直接登錄",
    nav4: "使用第三方直接登錄",
    nav5: "掃描二維碼",
    nav6: "下載并註冊LesPark",
    nav7: "或",
    nav8: "登錄",
    input1: "請輸入手機號",
    input2: "請輸入密碼",
    input3: "中國",
    input4: "美國",
    input5: "臺灣",
    input6: "香港",
    input7: "澳門",
    input8: "泰國",
    input9: "馬來西亞",
    input10: "新加坡",
    input11: "日本",
    input12: "韓國",
    input13: "澳大利亞",
    input14: "英國",
    input15: "菲律賓",
    input16: "越南"
  },
  live: {
    nav1: "關注",
    nav2: "我的關注",
    nav3: "熱門直播",
    nav4: "發送",
    nav5: "加載更多",
    nav6: "直播結束",
    nav7: "關注",
    nav8: "熱門"
  },
  home: {
    download: "掃碼下載",
    download1: "蘋果下載",
    download2: "安卓下載",
    download3: "谷歌下載",
    liveTitle1: "我的關注",
    liveTitle1_1: "暫時沒有您關註的主播正在直播,去看看熱門直播吧",
    liveTitle2: "熱門直播",
    liveTitle3: "熱門话题",
    liveTitle3_1: "暂时没有推荐话题",
    appProfile: "APP簡介",
    more: "查看全部"
  },
  swiper: {
    0: {
      h1Content: "百花計劃",
      h2Content: "拍短視頻，享千萬補貼"
    },
    1: {
      h1Content: "實時直播",
      h2Content: "高顏值主播和妳親密互動"
    },
    2: {
      h1Content: "多人視頻",
      h2Content: "視頻連麥 還有紅娘牽線"
    },
    3: {
      h1Content: "附近的人",
      h2Content: "發現妳身邊的同好圈"
    },
    4: {
      h1Content: "情侶公園",
      h2Content: "記錄相愛點滴"
    },
    5: {
      h1Content: "即時語聊",
      h2Content: "妳的聲音 甜過初戀"
    },
    6: {
      h1Content: "快速配對",
      h2Content: "交友脫單 心動匹配"
    }
  },
  foot: {
    // content1: '京公網安備 11010802023956號 ',
    // content2: ' 京ICP備14047082號-4 ',
    // content3: '北京高梓行远科技有限公司 2013-2017 All Rights Reserved 客服電話：010-56153450 舉報電話：010-56153450',
    // content4: ' 舉報郵箱：cs@lespark.us',
    // content5: ' 友情鏈接',
    // content6: '京網文（2017）1347-096號'
    content1: "粵公網安備 44180202000386號 ",
    content2: " 粵ICP備18016053號",
    content3: "清遠市帕克文化傳媒有限公司 2016-2020 All Rights Reserved ",
    content4: " 舉報郵箱：cs@lespark.us",
    content5: " 友情鏈接",
    content6: " 粵網文（2018）3153-1052號",
    HelpCenter: "幫助中心",
    PrivacyPolicy: "隱私政策",
    ServiceAgreement: "服務協議",
    ReportPhone: "違法與不良信息舉報電話",
    ReportEmail: "違法與不良信息舉報郵箱",
    CompanyProfile: "公司簡介",
    JoinUs: "加入我們",
    contactUs: "聯系我們",
    ServiceTel: "客服電話"
  },
  foot2: {
    content1: "桂公網安備 45050302000153號",
    content2: "桂ICP備20003447號-1",
    content3: "北海帕克信息科技有限公司 2016-2023 All Rights Reserved ",
    content6:"桂網文（2023）1925-390號",
  },

  live_star: {
    pc: "电脑直播",
    account: "LesPark賬號:",
    noLogin: "未登錄,",
    login: "點擊登錄",
    liveTitle: "直播標題:",
    liveCover: "直播封面:",
    oldLiveCover: "使用上次直播封面(頭像)",
    customimg: "自定義圖片",
    plugFlow: "推流地址:",
    copy: "復制",
    secret: "密鑰:",
    finishLive: "結束直播",
    getLiveAdd: "獲取直播地址",
    liveNote: "開播須知:",
    liveNote1: "1. 根據相關規定，開播前，請在LesPark app內完成實名認證。請您遵守",
    liveNote2: "2. 在本網頁登錄LesPark賬號，輸入標題、選擇封面後，點擊“開播獲取地址”按鈕",
    liveNote3: "3. 在OBS中配置推流地址和密鑰，點擊開始推流即可",
    liveNote4: "4. 直播結束時，請務必在本頁面點擊“結束直播”，否則直播間將處於黑屏影響觀看",
    convention: "LesPark直播公約"
  },
  mobile_login: {
    title: "請先登錄哦~",
    sendCode: "發送驗證碼",
    resendCode: "重新發送",
    btnName: "登錄",
    agreeLic: "注冊即視爲同意",
    lic: "《LesPark使用條款》",
    sendCodeFail: "發送驗證碼失敗",
    errPhoneFormat: "手機格式錯誤",
    errVerifyCodeRequired: "驗證碼不能為空",
    errVerifyCodeFormat: "驗證碼格式錯誤",
    success: "登錄成功",
    fail: "登錄失敗",
    phoneRequired: "請輸入手機號碼",
    verifyCodeRequired: "請輸入驗證碼"
  },
  dynamic: {
    comment: "評論",
    moreComment: "查看更多評論",
    liaoXjj: "去撩小姐姐",
    faXianXjj: "發現更多好看的姐姐",
    nodata: "帖子被發佈者刪除了，去LesPark發現更多有趣的帖子吧"
  },
  video: {
    comment: "輸入評論...",
    more: "更多精彩視頻",
    nodata: "短視頻被發佈者刪除了，去LesPark看看他的其他作品吧~",
    notSupport: "此視頻暫無發播放，請稍後再試",
    payTips:'目前為付費視頻，請進入app查看',
  },
  profile: {
    moreFriends: "發現更多有趣的小夥伴",
    years: "嵗",
    userId: "ID",
    fans: "粉絲",
    girlSounds: "蘿莉音",
    chat: "私聊",
    signature: "個人簽名",
    fullText: "全文",
    notSupportAudio: "您的瀏覽器不支持audio元素",
    nodata: "啊哦~這名用戶賬號注銷了，去LesPark發現更多有趣的小姐姐吧"
  },
  common: {
    follow: "關注",
    followed: "已關注",
    followFail: "關注失敗",
    goAndSeed: "去看看",
    like: "點贊",
    liked: "被讚",
    unlikeFail: "取消點贊失敗",
    likeFail: "點贊失敗",
    likedUnit: "人點贊"
  },
  downloadTip: {
    title: "到LesPark查看更多評論吧",
    textBtn: "去LesPark",
    video: "到LesPark App查看更多有趣的視頻吧~",
    profile: "到LesPark App瞭解小姐姐更多信息，跟小姐姐暢聊吧~",
    dynamic: "到LesPark發現更多有趣的帖子"
  },
  bottomBar: {
    video: "到LesPark發現更多有趣的短視頻",
    profile: "到LesPark發現更多有趣的小姐姐",
    dynamic: "到LesPark發現更多有趣的帖子"
  },
  error: {
    userNotExist: "用戶不存在",
    networkException: "網絡錯誤",
    phoneVerifyException: "號碼異常",
    paramInvalid: "參數錯誤",
    verifyCodeError: "驗證碼錯誤",
    unsafeEnv: "當前使用環境有風險（機審）",
    accountRegisted: "號碼已注冊",
    postNotFound: "帖子不存在或刪除",
    posterNotFound: "發帖人不存在",
    userNotFound: "用戶不存在"
  },
  baiHuaTxt: {
    bg1Title: "https://static.lespark.cn/pc_img/images/baihua/title-tw.png",
    award: ["￥", "2", "0", "0", "0", "W"],
    bg1Tips: "短視頻創作收益獎勵",
    bg1Tips2: "加入“百花計劃”發布原創優質視頻，享創作收益",
    rule: "規則說明",
    bg2Title: "LesPark全球最大的多元女性視頻平臺",
    bg2Tips: ["超多", "流量", "豐厚", "收益", "等妳拿"],
    bg2Img: "https://static.lespark.cn/pc_img/images/baihua/bg2Img-cn.png",
    bg2Tips2: "現金獎勵",
    bg2Tips3: "*成功加入”百花計劃“產生有效播放量，即可獲得超高收益",
    bg3Title: "LesPark誠邀每壹位創作者加入百花計劃",
    bg3Tips: ["讓每個", "獨壹無二的妳", "都被看見"],
    bg3Img: "https://static.lespark.cn/pc_img/images/baihua/tequan-tw.png",
    bg3Tips2: "以上僅為部分規劃，詳情請查看完整",
    bg3Tips3: "加入“百花計劃”前，請妳仔細閱讀活動規則及相關條款",
    bg3Tips4: "凡加入本計劃，則視為妳已閱讀，理解並同意規則全部內容",
    tqSvga: "https://static.lespark.cn/pc_img/images/baihua/tequan-tw.svga",
    titleSvga: "https://static.lespark.cn/pc_img/images/baihua/title-tw.svga",
  },
  photowall: {
    title: "全球多元女性社交",
    LaunchedYears: "上線7年+",
    millionsWomen: `2000萬+<br/>女性用戶`,
    content1: `服務全球`,
    content2: `千萬名多元女性`,
    content3: `撮合10000+<br/>對情侶`,
    content4: `1000多個<br/>交友房`
  },
  liveAll: {
    content1: "熱門直播",
    content2: "全部直播"
  },
  topicAll: {
    content1: "熱門話題",
    content2: "全部話題",
    join: "人參與"
  },
  headerOptions: [
    {
      value: "anchor",
      label: "主播管理",
      children: [
        {
          value: "pc",
          label: "開始PC直播"
        },
        // {
        //   value: 'backend',
        //   label: '主播管理後臺',
        // },
        {
          value: "invite",
          label: "優質直播招募"
        },
        {
          value: "sign",
          label: "簽約信息錄入"
        }
        // {
        //   value: 'withdraw',
        //   label: '提現',
        // },
      ]
    },
    {
      value: "union",
      label: "公會",
      children: [
        {
          value: "Trade",
          label: "公會入駐"
        },
        {
          value: "management",
          label: "公會管理"
        }
      ]
    }
  ],
  lesApp: {
    content1: "LesPark - 認識超過 2000 萬 多元女性",
    content2: "條評論",
    content3: "千萬女性記錄和分享生活的社交平臺，通過直播、語音聊天輕松表達真實自我，每天產生數十萬條原創新鮮視頻、語音、文字、圖片，分享發現真實有趣的世界，讓妳享受輕松交友的社交體驗。",
    content4: "LesPark的使命：鏈接全球少數人群，讓世界更寬容、更快樂",
    content5: "實時直播",
    content6: "這裏有陪伴妳的高顏值主播，陪妳聊天、唱歌，連接真實的妳和精彩的世界",
    content7: "多人視頻",
    content8: "紅娘在線，多人連線模式，讓妳孤獨的尋覓變成妳們姻緣的相遇",
    content9: "附近的人",
    content10: "精準的地理位置翻看附近優秀的多元女性，讓妳壹鍵GET身邊的她",
    content11: "視頻匹配",
    content12: "壹對壹視頻匹配聊天，真人視頻，拒絕偽裝，面對面零距離熱聊，瞬間了解彼此",
    content13: "情侶公園",
    content14: "多元女性情侶專屬空間，記錄每個相愛瞬間；完成情侶清單和每日打卡任務，獲得積分兌換精美禮品",
    content15: "語音派對",
    content16: "實時在線語音派對，跟眾多小姐姐壹起連麥聊天、唱歌、相親約會、玩遊戲，帶妳1秒終結孤單",
    content17: "即時語聊",
    content18: "10秒匹配遠方的她，與陌生人暢所欲言，結識新朋友，講故事，道晚安，發現好聽的聲音，讓聲音治愈妳",
    content19: "快速配對",
    content20: "交友脫單，單身待解救者，根據妳的喜好位置設置快速匹配興趣相投的她",
    content21: "用戶點評",
    content22: "來自29820位用戶評分",
    content23: "常見問題",
    content24: "App內會有男性用戶嗎？",
    content25: "不會，我們有審核客服運營團隊7*24小時在線嚴格審核，謝絕男性用戶進入，壹經發現將作封禁處理。",
    content26: "為什麽使用LesPark？",
    content27: "LesPark 作為專屬多元女性社交的應用程序，為女性創造壹個安全的空間，目標是提供壹個平臺來建立友善關系並進行對話，而沒有欺淩、偏見和社會風險。",
    content28: "LesPark收費嗎？",
    content29: "LesPark是免費的社交應用，可以在 App Store 和 安卓應用商店下載",
    content30: "LesPark會不會透露我的信息？",
    content31: "LesPark不會以任何形式向第三方透露用戶信息，以確保大家的隱私安全。",
    commentList: [
      {
        time: "2021-06-28",
        name: "珍惜",
        content: "在LesPark找到了現在的女朋友是我最幸運的事，壹直沒在軟件裏面發過動態，都是默默看別人，緣分就是那麽其妙吧，她還是把我找到了，果然還是要主動才行哈哈，祝願大家都找到屬於自己的幸福。"
      },
      {
        time: "2021-08-01",
        name: "花開",
        content: "因為這個圈子很小，顯示生活中是深櫃又不能標明自己的取向去大膽的找對象，用了這個軟件之後才發現自己的身邊有蠻多這樣的唉，還有附近的社群可以找到壹個跟妳壹個圈子的大家庭，感覺有了屬於自己的交際圈，很開心~"
      },
      {
        time: "2021-08-01",
        name: "Zhang",
        content: "軟件界面挺好看的，用來用去還是這個最靠譜，喜歡動態配對功能，好好玩，好多漂亮的小姐姐，因為裏面大家都是多元女性， 不必擔心別人異樣的眼光。良心軟件，加油挺好的贊。"
      },
      {
        time: "2021-08-13",
        name: "Christian",
        content: "這裏可以不用在意異樣的眼光，可以無限做自己，找到自己愛的人，找到相投的人做朋友，隨著軟件的壹步步更新，用戶體驗越來越好，內容也越來越豐富。~"
      },
      {
        time: "2021-09-01",
        name: "怡婷",
        content: "作為壹個多元女性以前感到很寂寞沒有人理解，現在有了朋友和社區真好，已經認識不少新朋友，發現大家顏值都好高呀，支持加油贊贊。"
      }
    ]
  },
  aboutUs: {
    content1: `LesPark 為清遠市帕克文化傳媒有限公司旗下研發的壹款為全球女性提供交友渠道的移動社交軟件。不論是想成為KOL，坐擁百萬粉絲；還是想交朋友、分享情感、漲知識LesPark都有專為身為女性的妳打造的便利平臺與真實社區。`,
    content1_1: `LesPark 為北海帕克信息科技有限公司旗下研發的壹款為全球女性提供交友渠道的移動社交軟件。不論是想成為KOL，坐擁百萬粉絲；還是想交朋友、分享情感、漲知識LesPark都有專為身為女性的妳打造的便利平臺與真實社區。`,
    content1_2: `LesPark 為 ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD. 旗下研發的壹款為全球女性提供交友渠道的移動社交軟件。不論是想成為KOL，坐擁百萬粉絲；還是想交朋友、分享情感、漲知識LesPark都有專為身為女性的妳打造的便利平臺與真實社區。`,
    content2: `在這裏，妳能夠通過社區、直播展示自己，與粉絲零距離實時互動；能夠依據定位加入附近群組參加各種活動，與附近人群建立良好、健康的社交關系。`,
    content3: `“Live for Love——為愛而生”，壹直以來都是LesPark的口號，力於打造女性群體記錄和分享生活的平臺。`,
    content4: `目前，LesPark已上線運營7年，擁有垂直領域用戶數已突破2000萬，分布全球34個國家，主播數量已超15萬。`,
    content5: `企業文化`,
    content6: `使命`,
    content7: `鏈接全球少數人群`,
    content8: `讓世界更加寬容、更快樂`,
    content9: `願景`,
    content10: `成為少數人群最可信賴的全球化公司`,
    content11: `在不斷地創新中建立少數人`,
    content12: `群普惠價值網絡`,
    content13: `價值觀`,
    content14: `用戶第壹、團隊協作`,
    content15: `結果導向、追求極致`,
    content16: `積極主動、勇敢無畏`,
    content17: `加入我們`,
    content18: `我們需要產品、運營、技術等各崗位人才，期待妳的加入！`,
    content19: `立即加入`,
    content20: `聯系我們`,
    content21: `聯系人`,
    content22: `張先生`,
    content23: `客服電話`,
    content24: `聯系地址`,
    content25: `舉報投訴`,
    content26: `廣東清遠市廣清大道八十八號雲山詩意花園雲山詩意大廈14層辦公室08號`,
    content26_1: `廣西壯族自治區北海市四川路299號穗豐金灣1幢0401號`,
    content26_2: `ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD.`,
  },
  loginHome: {
    content1: "加載更多",
    content2: "粉絲",
    content3: "獲贊",
    content4: "動態"
  },
  topicItem: {
    content1: "人贊",
    content2: "查看全部",
    content3: "條評論",
    content4: "回復",
    content5: "評論...",
    content6: "發送"
  },
  baihuaRule: {
    title: "百花計劃活動規則",
    ruleSet: [
      `加入短視頻百花計劃（以下簡稱“本計劃”）前，請用戶詳細閱讀活動規則及相關條款。凡申請加入百花計劃，則視為用戶已閱讀、理解並同意活動規則全部內容。`,
      `<h3 class="h3-label">計劃介紹</h3>`,
      `百花計劃是由LesPark平臺舉辦的激勵短視頻創作的活動。成功加入百花計劃的作者，通過站內發布的<span>原創高清視頻（時長≥10秒)</span>，有機會享受創作收益。`,
      `<h3 class="h3-label">計劃的加入方式</h3>`,
      `1.妳可通過點擊計劃介紹頁面的“立即加入”按鈕並完成相應的申請任務，即可申請加入百花計劃。`,
      `2.申請加入百花計劃前，需要完成以下申請任務，平臺將根據活動規則對申請者的視頻內容質量進行審核，審核通過後即可成功加入百花計劃。`,
      `1)完成手機號綁定，以及實名認證<br/>
2)近30天內，通過LesPark App發布過大於等於5篇公開可見的、原創高清視頻（清晰度≥720P）、時長≥10秒<br/>
3)近30天內，通過LesPark App發布的所有公開可見的、原創高清視頻（時長≥10秒)的總播放量達到60000
`,
      `3.當妳完成申請任務時，可點擊按鈕，提交審核。官方工作人員將根據賬號發布的原創高清視頻（時長≥10秒) 以及內容質量標準（詳見規則：<a href="/baihuaQualityReview.html">內容質量審核</a>）等要求，來確定妳是否可以加入本計劃。審核結果將通過計劃介紹頁面和消息通知公布。`,
      `1)如果由於不符合內容質量標準等原因未審核通過，妳可以根據相應的提示原因或者建議，進行調整，或者嘗試再次發布至少5篇原創高清視頻（時長≥10秒)，調整完成後可再次提交審核申請。
      2)平臺優先鼓勵自主拍攝及創作的創作者加入本計劃。
      3)當前賬號為註銷、刪除、封禁等異常狀態時，無法加入百花計劃。
      4)創作的視頻需滿足平臺原創標準（詳見規則：<a href="/baihuaOriginalStandards.html">原創標準</a>），不存在色情、低俗、畫面不清晰、刷粉刷播放量等不良問題。不涉及未成年、廣告營銷、黑產教學、言論攻擊、無資質講解財經等負面導向問題。同時註意，若賬號中大量都是無意義隨拍或基於壹定素材簡易加工，創作程度較低的視頻，也無法加入百花計劃。
      `,
      `<h3 class="h3-label">計劃收益</h3>`,
      `1.視頻創作收益<br/>
        成功加入計劃後，通過LesPark App發布的原創高清視頻（時長≥10秒)，若播放量達到2w、通過內容質量審核、視頻作品處於“收益中”狀態下，該作品的收益播放量均可獲得創作收益。註意：單個視頻作品的收益期為發布並通過審核後的90天內，超過90天會被設置為“收益過期”；若視頻作品未通過審核，則會被設置為“審核失敗”；通過審核，且未超過90天周期內，則會被設置為“收益中”狀態。
        2.收益查看與提現<br/>
        1)加入百花計劃後獲得的收益可在LesPark App——我的——側邊欄——創作者中心，查看相關收益，也可在LesPark App——我的——側邊欄——鉆石錢包，進行查看。<br/>
        2)收益的提現，每天最多申請1次，可依據可提額度，選擇對應檔位金額與平臺，提交提現申請，提現審核通過後，會進行相應打款操作。
        `,
      `<h3 class="h3-label">計劃違規說明</h3>`,
      `1.LesPark官方有權對參與本活動的用戶進行安全驗證<br/>
如參與本活動的用戶曾經存在、出現或經LesPark官方合理懷疑存在違反法律法規或LesPark平臺規則、違背誠實信用原則的行為，LesPark官方有權采取包括但不限於限制註冊/登錄LesPark App、禁止參與本活動、撤銷活動參與資格、取消或凍結獲得活動收益(包括但不限於通過參與活動可能會獲得的虛擬物品、現金、實物等收益)的資格、無法獲取或僅可獲取部分活動收益、已獲取的活動收益使用/提現受到全部/部分限制、收回已發放的活動收益、封禁帳號等處置措施，同時保留追究該用戶相關法律責任的權利。
違背誠實信用原則的行為包括但不限於：<br/>
1)下載非官方客戶端；<br/>
2)使用高危作弊嫌疑的手機號、虛擬手機號、QQ、微信號等第三方平臺帳號註冊/登錄LesPark App；<br/>
3)修改頁面參數、篡改設備數據；<br/>
4)以任何機器人軟件、蜘蛛軟件、爬蟲軟件、刷屏軟件或任何非人工方式參與活動；<br/>
5)使用模擬器、插件、外掛、App分身軟件等非法工具掃碼、下載、安裝、註冊、登錄LesPark客戶端、參與活動、領取活動收益、提現、進行活動收益贈與；<br/>
6)通過惡意牟利手段擾亂平臺秩序；<br/>
7)使用插件、外掛、群控系統或第三方工具對LesPark平臺及本活動進行幹擾、破壞、修改或施加其他影響；<br/>
8)與其他用戶串通或利用機器等方式進行作弊、刷取活動收益等擾亂活動秩序的行為；<br/>
9)其他LesPark平臺有合理理由懷疑的違背誠實信用原則的行為。<br/>
<br/>
2.用戶在參加本系列活動過程中，如存在以所獲得的活動獎勵進行任何盈利或非法獲利、以任何形式轉讓或轉移其通過活動所獲得的獎勵，或LesPark官方有合理理由懷疑用戶存在不正當使用活動獎勵，擾亂LesPark平臺秩序的，LesPark官方有權取消用戶的活動參與資格、收回已發放的活動獎勵(含已使用及未使用的) 同時保留追究該用戶相關法律責任的權利。
<br/><br/>
3.LesPark官方特別提示您，請您務必通過LesPark官方及LesPark官方指定路徑參與本系列活動，因用戶參與任何非LesPark官方活動或冒用LesPark名義開展的活動，造成用戶損失的，LesPark對此不承擔任何法律責任。
`,
      `<h3 class="h3-label">註意事項</h3>`,
      `1.按照相關法律規定，主辦方需就獲獎者在本活動下所得進行代扣代繳個人所得稅的，主辦方有權依法代扣代繳。未經主辦方事先書面許可，用戶因參加本活動所取得的權利或獲得的獎勵均不得轉讓。<br/>
2.用戶不得以任何不正當手段或舞弊方式參與本活動或利用本活動從事違法行為。壹經發現，主辦方有權采取降低活動獎勵、限制提現、賬號金額清零、撤消活動資格、限制登錄、封禁賬號、限制再次註冊使用等措施，亦有權收回用戶已領取的獎勵、追討已提現的金額，並保留追究該用戶責任的權利。<br/>
3.主辦方依法運營此次活動，如因不可抗力、情勢變更、相關政策變動、政府機關指令要求、活動參與人數不足、第三方原因等非主辦方原因導致本次活動調整、暫停舉辦、無法進行、用戶參與失敗的，主辦方有權隨時決定修改、暫停、取消或終止本活動，並無需為此承擔任何法律責任。用戶自身原因導致參與失敗的，不利後果由用戶自行承擔。用戶可在本頁面隨時查看修改後的活動規則，若用戶對修改後的活動規則有異議的，請停止繼續參與，若用戶繼續參加本活動，則視為用戶同意本活動規則的修改。<br/>
4.《LesPark使用條款》、《LesPark隱私政策》同樣適用於本次活動，本次活動規則及相關條款與《LesPark使用條款》、《LesPark隱私政策》相沖突的，以本次活動規則及相關條款為準。本次活動規則及相關條款未約定的內容，仍以《LesPark使用條款》、《LesPark隱私政策》為準。<br/>
5.如果妳在活動中遇到任何問題，可以打開 LesPark App，通過人工客服或者聯系微信官方號等渠道，進行咨詢。<br/>
6.本活動與Apple Inc.無關<br/>
`
    ]
  },
  baihuaOriginalStandards: {
    title: "百花計劃 原創標準說明",
    ruleSet: [
      `<div class="h3-label">原創作品定義</div>`,
      `1.實拍類：個人或團隊親自獨立創作的視頻，並擁有作品內所有內容的相關版權<br/>
(1)視頻內容畫面幹凈整潔，主題明確、內容完整有記憶點，賬號內容風格統壹；<br/>
(2)真人出鏡類視頻，需有明確的人設屬性，出鏡人與賬號實名認證信息需保持壹致；<br/>
(3)非真人出鏡的視頻，需有明確的主題定位，可根據作品的垂類、風格、賬號特征、作者提供的材料等判斷賬號下內容屬於當前賬號創作；
`,
      `2.二次剪輯創作類作品<br/>
(1)在適度引用原視頻素材基礎上，二次創作成為壹個豐富、有信息量、有自己編輯思路、有獨創性的新視頻作品；<br/>
(2)二次創作形式包括但不限於體現自己想法和思考的解說點評、剪輯制作、特效包裝、音頻處理等；
`,
      `3.以下類型不屬於原創作品<br/>
(1)上傳與他人相似的作品：<br/>
● 直接搬運、錄屏、屏拍他人作品上傳發布；<br/>
● 在未獲得版權方授權或無版權的情況下，發布（或直接上傳）影視劇、綜藝、動漫、音樂MV、新聞、遊戲體育賽事等版權內容<br/>
● 純錄屏類內容，對創作人沒有參與攝像、錄制、加工的作品進行錄播`,
      `(2)二次創作程度不高的內容<br/>
● 內容豐富度低，如對原有素材進行簡單剪輯拼接，或簡單添加短暫的開場白、場景過渡串場詞、背景音樂等<br/>
● 二創成本較低，僅對視頻素材或文案進行簡單的翻譯、配音生硬刻板等；或使用他人音頻作品，僅簡單配上視頻畫面<br/>
● 解說信息單薄，沒有明確的主題和個人有效信息價值觀點輸出，視頻內的解說文案涉嫌抄襲、觀點來自網絡<br/>
● 引用素材低質，如引用視頻和圖像素材存在模糊抖動、拉伸放大/縮小、明顯黑邊等情況<br/>
● 引用素材和視頻主題的關聯性低`,
      `(3)壹文多發<br/>
● 同壹視頻發布在自己/公司不同的賬號，且均聲明原創<br/>
● 在同壹賬號內，同壹視頻重復聲明原創，特殊情況下可豁免，比如：第壹遍發布有誤但很快刪除、在第壹次發布視頻的基礎上繼續完善內容且加工點豐富<br/>`,
      `(4)無法證明原創性質的作品：<br/>
● 賬號發布圖集作品，且無法證明原創性：賬號發布低質量圖片作品，如文字信息類截圖、空洞無意義的隨手拍、傷感句子、經典語錄等圖片等；賬號發布明顯網圖作品，如明星、美女、網紅介紹等
`]
  },
  baihuaQualityReview: {
    title: "百花計劃 內容質量審核規則",
    ruleSet: [
      `<div class="h3-label">壹、優質原創作者</div>`,
      `1.具備穩定生產能力，在LesPark持續、穩定更新作品<br/>
2.作者生產的作品領域垂直，風格統壹，有個人特色<br/>
3.作者堅持生產原創作品，尊重創作、尊重版權<br/>
4.作者持續生產優質作品，帶給用戶良好的觀看體驗<br/>
`,
      `<div class="h3-label">二、優質作品</div>`,
      `1.作品觀看體驗好<br/>
(1)作品質量優質：<br/>
● 封面：封面視覺沖擊感強，風格統壹，突出重點，有助於用戶在觀感上形成壹個系列的認知<br/>
● 標題：標題直觀突出，與內容相關，無標題誇張等問題<br/>
● 畫面：視頻畫面美觀清晰、無噪點，對比度適宜；視頻畫面完整，無水印過多、拉升、放大裁剪導致畫面不全、黑邊等問題<br/>
● 聲音：視頻音畫同步、無雜音，人物臺詞聲音清晰、音量適宜<br/>
● 字幕：視頻字幕完整可見，字幕與視頻畫面、視頻聲音同步<br/>
● 節奏：視頻流暢，播放不卡頓，情節完整，有頭有尾<br/>
(2)作品滿足時效性、專業性、實用性、趣味性等其壹特征<br/>
(3)作品思想完整，表達主旨明確清晰，作品整體觀感的舒適度、愉悅性、觀賞性強`,
      `2.作品創作成本高<br/>
(1)生產前期：作品有完整的構思，拍攝過程存在腳本、情節、文案設計、演員等<br/>
(2)生產後期：通過添加字幕、背景音樂等提升視頻可看性，視頻剪輯流暢，視頻完整度高
`,
      `<div class="h3-label">三、非優質作品</div>`,
      `(1)制作簡單粗糙：<br/>
● 日常生活隨手拍，內容空洞/無具體實際意義/隨手拍攝/無觀賞價值/缺乏可看性<br/>
● 直播預告、直播錄屏等內容，無再次加工且內容單薄、畫面單壹<br/>
● 網絡圖片拼湊類圖集作品<br/>
(2)畫面觀感不適：<br/>
● 視頻給人帶來嚴重的畫面沖擊感，引人不適，如血腥、密集畫面<br/>
(3)不良價值觀:<br/>
● 視頻宣傳不良風氣和不當行為，如拜金、賣慘、不文明用詞、打架鬥毆等<br/>
(4)營銷推廣/誘導要贊：<br/>
● 以盈利為目的的純廣告、引導用戶線下交易<br/>
● 通過情感綁架求贊求關註的惡意騙流行為<br/>
(5)謠言偽科學<br/>
● 傳播未經證實的虛假消息、封建迷信和違背科學規律的內容
`
    ]
  },
  mobleTxt:{
    t1:'優質主播申請',
    download:'壹鍵下載',
    download2:'立即下載',
    more:'查看更多',
    lesAppTitle:'- 認識超過 2000 萬 多元女性',
    aboutUsT1:'雖小眾 不孤獨',
  },
};



// WEBPACK FOOTER //
// ./static/js/zh-f.js